import React from "react";
import { HiOutlineFilm } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import type { Column } from "../../../ui";
import { _TYPES_ } from "../utils/types";
import { pushOneCinema } from "../../../lib/sysNavigation/SysNavigation";

type CinemaRow = {
  cinema_id: number | string;
  title?: string;
  open_days?: string;
  [key: string]: unknown;
};

const extraColumns: Column<CinemaRow>[] = [
  {
    header: "Open Days",
    cell: (row) => (
      <span className="text-gray-600">{row.open_days ?? "—"}</span>
    ),
  },
];

const Overview: React.FC = () => (
  <DoSeeListPage<CinemaRow>
    type={_TYPES_.CINEMA}
    title="Cinemas"
    subtitle="Cinema venues promoted on the public site."
    icon={<HiOutlineFilm className="h-5 w-5" />}
    addRoute="/data/cinema/add"
    editRoute="/data/cinema/edit"
    pushOne={pushOneCinema}
    dataKey="cinema"
    countKey="cinemaCount"
    idField="cinema_id"
    extraColumns={extraColumns}
  />
);

export default Overview;
